import { DatePipe, Location } from "@angular/common";
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MatTable } from "@angular/material/table";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { DateTime } from "luxon";
import { Subscription, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { EventEmitter } from "@angular/core";
import { environment } from "../../../environments/environment";
import { TicketCutoffTypeEnum } from "../../enum/cutoff-type.enum";
import { MenuConstants } from "../../infrastructure/MenuConstants";
import { TicketType } from "../../model/domain/Entity";
import { PagedList } from "../../model/domain/PagedList";
import {
  VariableIncome,
  VariableIncomeRowItem,
} from "../../model/domain/VariableIncome";
import { AuthService } from "../../services/auth.service";
import { CutoffService } from "../../services/cutoff.service";
import { DialogService } from "../../services/dialog.service";
import { LoaderService } from "../../services/loader.service";
import { SnackbarService } from "../../services/snackbar.service";
import { TicketService } from "../../services/ticket.service";
import { ValidatorService } from "../../services/validator.service";
import { Roles } from "../auth/auth.role";
import { TicketCutoffPermission } from "../cutoff/ticket-cutoff-type.model";

@Component({
  selector: "app-rv",
  templateUrl: "./rv.component.html",
  styleUrls: ["./rv.component.scss"],
})
export class RendaVariavelComponent implements OnInit, OnDestroy {
  constructor(
    private service: TicketService,
    public validator: ValidatorService,
    private route: ActivatedRoute,
    private snackBarService: SnackbarService,
    private router: Router,
    private location: Location,
    private dialogService: DialogService,
    private authService: AuthService,
    private loaderService: LoaderService,
    private datePipe: DatePipe,
    private cutoffService: CutoffService
  ) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.resetForm();
      }
    });
  }

  @ViewChild("thisForm", { static: true }) public frm: NgForm;
  @ViewChild("subForm") public subFrm: NgForm;
  @ViewChild("table", { static: true })
  public table: MatTable<VariableIncomeRowItem>;

  dataChanged: EventEmitter<string>;

  model: VariableIncome;
  VariableIncomesItems: VariableIncomeRowItem[] = [];
  canValidate = false;
  isEditing = false;
  columns: string[];

  deleted: number[];

  currentPage: number = 1;
  totalPages: number = null;
  totalItems: number = null;
  listedPages: any[];
  firstItemOnPage: number;
  lastItemOnPage: number;
  _rvPageSize: number = 10;

  navigationSubscription: Subscription;

  newItem: VariableIncomeRowItem;

  validators = {};
  isNotProduction = environment.name != 'production';

  ngOnInit() {
    this.dataChanged = new EventEmitter<string>();
    this.modelInit();
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  modelInit() {
    this.getTicket();
  }

  getTicket(idBoleta: number = null) {
    this.model = new VariableIncome();
    this.newItem = new VariableIncomeRowItem();
    this.columns = [
      "MarketType",
      "BuySell",
      "Asset",
      "Amount",
      "Price",
      "TotalPrice",
      "Actions",
    ];

    this.deleted = [];
    this.VariableIncomesItems = [];

    const id =
      idBoleta === null ? +this.route.snapshot.paramMap.get("id") : idBoleta;
    this.model.id = id;
    this.model.sellTotal = 0;
    this.model.buyTotal = 0;

    if (id) {
      this.service.VariableIncome.getTicketPaged(
        id,
        this.currentPage,
        this._rvPageSize
      ).subscribe((q) => {
        this.model = q;
        this.VariableIncomesItems = this.model.pagedResultItems.results;

        if (this.model.stockExchangeDate) {
          this.model.stockExchangeDate = this.datePipe.transform(
            this.model.stockExchangeDate,
            "dd/MM/yyyy"
          ) as any;
        }

        this.renderPaginador(this.model.pagedResultItems, 1);

        this.isEditing = true;
        this.canValidate = true;

        this.dataChanged.emit("");

        this.setEnable(false);
      });
    } else {
      if (!this.model.statusId) {
        this.model.operationDate = new Date();
      }
    }
  }

  resetForm() {
    this.frm.resetForm();
    this.model = new VariableIncome();

    this.isEditing = false;
    this.canValidate = false;

    this.model.items = [];
    this.deleted = [];

    this.model.operationDate = new Date();

    this.setEnable(false);
  }

  setEnable(enabled: boolean = false) {
    setTimeout(() => {
      if (enabled) {
        Object.values(this.frm.controls).forEach((c) => {
          c.enable();
        });
      } else if (!this.canEdit()) {
        Object.values(this.frm.controls).forEach((c) => {
          c.disable();
        });
      }
    }, 10);
  }

  hasError(prop: string) {
    if (!this.canValidate) {
      return false;
    }

    return !this.validators[prop](this.model[prop]);
  }

  getErrors(): string[] {
    const validationErrors = [];

    Object.keys(this.validators).forEach((k) => {
      if (!this.validators[k](this.model[k])) {
        validationErrors.push(k);
      }
    });

    return validationErrors;
  }

  getVariableIncomeListItem(page: number, pageSize: number) {
    this.service.VariableIncome.listTicketItemsById(
      this.model.id,
      page,
      pageSize
    ).subscribe((q) => {
      this.model.pagedResultItems = q;
      this.VariableIncomesItems = this.model.pagedResultItems.results;

      this.renderPaginador(this.model.pagedResultItems, page);
    });
  }

  addItem() {
    const f = this.subFrm;

    Object.values(f.controls).forEach((c) => {
      c.markAsTouched();
      c.updateValueAndValidity();
    });

    this.canValidate = true;

    if (f.invalid) {
      this.snackBarService.open("Verifique os campos destacados.", "OK");

      return;
    }

    const data = Object.assign({}, this.newItem);

    data.newItem = true;
    data.price = this.validator.getCurrency(data.price);
    data.amount = this.validator.getCurrency(data.amount);

    if (data.buySell === "C") {
      this.model.buyTotal += data.price * data.amount;
    } else if (data.buySell === "V") {
      this.model.sellTotal += data.price * data.amount;
    }

    this.VariableIncomesItems.push(data);
    this.table.renderRows();
  }

  removeItem(element: VariableIncomeRowItem, index) {
    if (!element.newItem) {
      this.deleted.push(element.id);
    }

    if (element.buySell === "C") {
      this.model.buyTotal -= element.price * element.amount;
    } else if (element.buySell === "V") {
      this.model.sellTotal -= element.price * element.amount;
    }

    this.VariableIncomesItems.splice(index, 1);
    this.table.renderRows();
  }

  submit() {
    const editing = this.isEditing;

    this.register(this.frm)
      .pipe(
        catchError((err) => {
          this.snackBarService.open(err, "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });
          return throwError(err);
        })
      )
      .subscribe(
        (r) => {
          const msg = editing ? "Boleta alterada." : "Boleta cadastrada.";

          this.snackBarService.open(msg, "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });

          this.dataChanged.emit("");
        },
        () => {}
      );
  }

  register(f: NgForm) {
    const editing = this.isEditing;

    if (!this.canEdit()) {
      return;
    }

    Object.values(f.controls).forEach((c) => {
      c.markAsTouched();
      c.updateValueAndValidity();
    });

    this.canValidate = true;

    const errors = this.getErrors();

    if (f.invalid || errors.length > 0) {
      return throwError("Verifique os campos destacados.");
    }

    if (this.VariableIncomesItems.length === 0) {
      return throwError("A boleta deve conter no mínimo 1 item.");
    }

    const data = Object.assign({}, this.model);

    data.operationDate = null;
    data.statusId = null;
    data.id = null;

    data.items = this.VariableIncomesItems;
    data.deleted = this.deleted;

    if (data.stockExchangeDate != null) {
      data.stockExchangeDate = new Date(
        data.stockExchangeDate
          .toString()
          .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
      );
    }
    if (data.operationDate) {
      data.operationDate = new Date(
        data.operationDate
          .toString()
          .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
      );
    }

    if (f.invalid) {
      return throwError("Verifique os campos destacados.");
    }

    this.loaderService.addLoader();

    const method = editing
      ? this.service.VariableIncome.updateTicket(this.model.id, data)
      : this.service.VariableIncome.registerTicket(data);

    return method
      .pipe(
        catchError((err) => {
          this.loaderService.removeLoader();
          return throwError("Erro ao cadastrar a boleta.");
        })
      )
      .pipe(
        map((variableIncome: VariableIncome) => {
          this.loaderService.removeLoader();

          if (!editing) {
            this.model.id = variableIncome.id;
            this.model.operationDate = variableIncome.operationDate;
            this.model.statusId = variableIncome.statusId;
            this.model.accountManagerName = variableIncome.accountManagerName;
            this.model.accountManagerDocument =
              variableIncome.accountManagerDocument;

            this.VariableIncomesItems.forEach((i) => {
              i.newItem = false;
            });

            this.isEditing = true;

            const url = this.router.createUrlTree([this.model.id], {
              relativeTo: this.route,
            });
            this.location.go(url.toString());
          }

          return this.model;
        })
      );
  }

  confirmForward() {
    if (!this.canEdit()) {
      return Promise.resolve(false);
    }

    var textConfirm = 'A boleta não poderá mais ser editada, deseja continuar?';

    if(this.isNotProduction) {
      textConfirm += '<br />ATENÇÃO: ESTE É UM AMBIENTE DE TESTE. NÃO EXECUTE OPERAÇÕES REAIS.';
    }

    return this.dialogService
      .confirm(
        "Encaminhar Boleta",
        textConfirm
      )
      .toPromise()
      .then((result) => {
        if (!result) {
          return false;
        }

        const operationDate = DateTime.fromJSDate(
          new Date(this.model.operationDate.toString())
        );

        if (operationDate.day < DateTime.local().day) {
          return this.dialogService
            .confirm(
              "Boleta Retroativa",
              "A data de operação da boleta será alterada para a data de hoje.",
              "OK",
              "Cancelar"
            )
            .toPromise();
        }

        return true;
      });
  }

  async forward() {
    const cutoffPermission = await this.checkPermission();

    if (!cutoffPermission.isAllowed) {
      this.snackBarService.open(
        this.cutoffService.warningMessage +
          this.cutoffService.dateTimeOffsetToTimeString(
            cutoffPermission.timeLimit
          ),
        "OK"
      );
      return;
    }

    this.confirmForward().then((ok) => {
      if (!ok) {
        return;
      }

      this.register(this.frm)
        .pipe(
          catchError((err) => {
            this.snackBarService.open(err, "OK", {
              verticalPosition: "top",
              horizontalPosition: "right",
            });
            return throwError(err);
          })
        )
        .subscribe(
          (variableIncome: VariableIncome) => {
            this.service.VariableIncome.forwardTicket(
              variableIncome.id
            ).subscribe((res) => {
              this.model.statusDescription = res.statusDescription;

              this.setEnable(false);

              this.snackBarService.open("Boleta encaminhada.", "OK", {
                verticalPosition: "top",
                horizontalPosition: "right",
              });

              this.getTicket(variableIncome.id);

              this.dataChanged.emit("");
            });
          },
          () => {}
        );
    });
  }

  approve() {
    this.dialogService
      .confirm("Aprovar Boleta", "Deseja aprovar esta boleta?")
      .subscribe((result) => {
        if (result) {
          this.service.approve(this.model.id, "").subscribe(() => {
            this.snackBarService.open("Boleta atualizada com sucesso.", "OK", {
              verticalPosition: "top",
              horizontalPosition: "right",
            });

            this.getTicket();
          });
        }
      });
  }

  reject() {
    this.dialogService
      .confirm("Reprovar Boleta", "Deseja reprovar esta boleta?")
      .subscribe((result) => {
        if (result) {
          this.service.reject(this.model.id, "").subscribe(() => {
            this.snackBarService.open("Boleta atualizada com sucesso.", "OK", {
              verticalPosition: "top",
              horizontalPosition: "right",
            });
            this.getTicket();
          });
        }
      });
  }

  renderPaginador(result: PagedList<any>, page: number) {
    this.totalItems = result.rowCount;
    this.totalPages = result.pageCount;
    this.firstItemOnPage = result.firstRowOnPage;
    this.lastItemOnPage = result.lastRowOnPage;
    this.currentPage = page;
    this.listedPages = [];

    let startPage = this.currentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.currentPage + 2;
    while (maxPage > this.totalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.listedPages.push(i);
    }

    if (!result.results.length) {
      this.totalPages = 1;
      this.currentPage = 1;
      this.firstItemOnPage = 0;
      this.listedPages = [];
      this.listedPages.push(1);
    }
  }

  duplicate(): void {
    this.service.VariableIncome.duplicateTicket(this.model.id).subscribe(
      (newTicket) => {
        this.snackBarService
          .open("Boleta duplicada.", "Visualizar no Monitor", {
            verticalPosition: "top",
            horizontalPosition: "right",
            duration: 6000,
          })
          .onAction()
          .subscribe((a) => {
            this.router.navigate([
              MenuConstants.Todos,
              { ticketId: TicketType.VariableIncome },
            ]);
          });
      }
    );
  }

  canEdit() {
    return (
      !this.model.statusId &&
      !this.model.statusDescription &&
      this.authService.hasRole(Roles.CreateTicketVariableIncome)
    );
  }

  checkPermission(): Promise<TicketCutoffPermission> {
    const cutoffTypeId = TicketCutoffTypeEnum.VariableIncome;
    return this.cutoffService.isAvailable(
      cutoffTypeId,
      this.model.id,
      this.model.accountManagerId,
      0
    );
    // return this.cutoffService.isAvailable(cutoffTypeId, this.model.id, this.model.accountManagerId, this.model.portfolioFundId);
  }

  canDuplicate() {
    return (
      this.model.id &&
      this.authService.hasRole(Roles.CreateTicketVariableIncome)
    );
  }

  canChangeStatus() {
    return (
      this.model.statusId &&
      this.authService.hasRoles(this.model.statusRequiredRoles)
    );
  }
}
